import { render, staticRenderFns } from "./PantallaInicio.vue?vue&type=template&id=a5e2c94c&scoped=true&"
import script from "./PantallaInicio.vue?vue&type=script&lang=js&"
export * from "./PantallaInicio.vue?vue&type=script&lang=js&"
import style0 from "./PantallaInicio.vue?vue&type=style&index=0&id=a5e2c94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e2c94c",
  null
  
)

export default component.exports